export const INSTAGRAM_PACKAGE = 'com.instagram.android';
export const INSTAGRAM_ACTIVITY = 'com.instagram.mainactivity.MainActivity';
export const TIKTOK_PACKAGE = 'com.zhiliaoapp.musically';
export const TIKTOK_ACTIVITY = 'com.ss.android.ugc.aweme.splash.SplashActivity';
/** TikTok's regional build (parts of Asia). Seen on a farm vivo V2332, Android 15,
 *  TikTok 40.7.3 (2026-10-16); same launcher activity as the global app. */
export const TIKTOK_REGIONAL_PACKAGE = 'com.ss.android.ugc.trill';
export const YOUTUBE_PACKAGE = 'com.google.android.youtube';
export const YOUTUBE_ACTIVITY = 'com.google.android.apps.youtube.app.WatchWhileActivity';
export const TWITTER_PACKAGE = 'com.twitter.android';
export const TWITTER_ACTIVITY = 'com.twitter.android.StartActivity';
export const FACEBOOK_PACKAGE = 'com.facebook.katana';
export const FACEBOOK_ACTIVITY = 'com.facebook.katana.LoginActivity';
export const MEDIA_PATH_REMOTE = '/sdcard/DCIM/Camera/';
export const DEVICE_POLL_INTERVAL_MS = 30_000;
export const HEALTH_CHECK_INTERVAL_MS = 60_000;
export const WEBSOCKET_HEARTBEAT_INTERVAL_MS = 15_000;
export const MAX_RETRIES = 3;
export const TASK_TIMEOUT_MS = 300_000;
export const SCREEN_WIDTH = 1080;
export const SCREEN_HEIGHT = 1920;
export const MIN_HUMAN_DELAY_MS = 500;
export const MAX_HUMAN_DELAY_MS = 3000;
export const TYPING_SPEED_MIN_MS = 80;
export const TYPING_SPEED_MAX_MS = 200;
export const SCROLL_SPEED_MIN_MS = 100;
export const SCROLL_SPEED_MAX_MS = 300;
export const MAX_ACCOUNTS_PER_DEVICE = 6;
export const ACCOUNT_CLUSTER_WARNING_THRESHOLD = 1;
export const ACCOUNT_CLUSTER_CRITICAL_THRESHOLD = 2;
//# sourceMappingURL=device.constants.js.map